module.exports = __webpack_public_path__ + "img/beiantubiao.d0289dc0.png";